import Marquee from "react-fast-marquee";

const clients = [
  {
    name: "Park Holidays UK",
    logo: "https://customer-assets-lqy194kg.emergentagent.net/job_entertainment-hub-187/artifacts/42jxduiw_Phuk_logo.gif",
  },
  {
    name: "Lady's Mile Holiday Park",
    logo: "https://customer-assets-lqy194kg.emergentagent.net/job_entertainment-hub-187/artifacts/nieu4yoz_ChatGPT%20Image%20Jul%2022%2C%202026%2C%2010_11_41%20PM.png",
  },
  {
    name: "New Beach Holiday Park",
    logo: "https://customer-assets-lqy194kg.emergentagent.net/job_entertainment-hub-187/artifacts/1ss2obtu_ChatGPT%20Image%20Jul%2022%2C%202026%2C%2010_11_30%20PM.png",
  },
  {
    name: "Seawick Holiday Park",
    logo: "https://customer-assets-lqy194kg.emergentagent.net/job_entertainment-hub-187/artifacts/yhplzo5l_ChatGPT%20Image%20Jul%2022%2C%202026%2C%2010_11_14%20PM.png",
  },
  {
    name: "Golden Sands Holiday Park",
    logo: "https://customer-assets-lqy194kg.emergentagent.net/job_entertainment-hub-187/artifacts/ru8vldg3_Golden%20Sands.jpg",
  },
  {
    name: "Chichester Lakeside Holiday Park",
    logo: "https://customer-assets-lqy194kg.emergentagent.net/job_entertainment-hub-187/artifacts/okcf7raf_ChatGPT%20Image%20Jul%2022%2C%202026%2C%2010_42_46%20PM.png",
  },
  {
    name: "St Osyth Beach Holiday Park",
    logo: "https://customer-assets-lqy194kg.emergentagent.net/job_entertainment-hub-187/artifacts/rm8yhj0h_ChatGPT%20Image%20Jul%2022%2C%202026%2C%2010_44_56%20PM.png",
  },
  {
    name: "Broadland Sands Holiday Park",
    logo: "https://customer-assets-lqy194kg.emergentagent.net/job_entertainment-hub-187/artifacts/9dsmz848_ChatGPT%20Image%20Jul%2022%2C%202026%2C%2010_46_02%20PM.png",
  },
  {
    name: "Sand leMere Holiday Park",
    logo: "https://customer-assets-lqy194kg.emergentagent.net/job_entertainment-hub-187/artifacts/duvnhwyz_ChatGPT%20Image%20Jul%2022%2C%202026%2C%2010_48_14%20PM.png",
  },
  {
    name: "Dovercourt Holiday Park",
    logo: "https://customer-assets-lqy194kg.emergentagent.net/job_entertainment-hub-187/artifacts/gyjnovwx_ChatGPT%20Image%20Jul%2022%2C%202026%2C%2010_39_19%20PM.png",
  },
];

export const LogoMarquee = () => {
  return (
    <section className="py-8 border-y border-[#D4AF37]/25 bg-[#0D0D0D]" data-testid="client-marquee-section">
      <p className="text-center text-sm sm:text-base font-semibold tracking-[0.25em] uppercase text-[#D4AF37] mb-6">
        Trusted by leading UK holiday and leisure brands
      </p>
      <Marquee gradient gradientColor="#0D0D0D" gradientWidth={120} speed={45} pauseOnHover autoFill>
        {clients.map((c) => (
          <div
            key={c.name}
            className="mx-8 flex items-center justify-center px-6 py-3 rounded-xl border border-white/10 bg-white overflow-hidden"
          >
            <img
              src={c.logo}
              alt={c.name}
              className="h-16 w-auto object-contain"
              data-testid={`marquee-logo-${c.name.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
            />
          </div>
        ))}
      </Marquee>
    </section>
  );
};

export default LogoMarquee;
